import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpResponse, HttpParams, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { tap, shareReplay, retry, map, catchError, switchMap } from 'rxjs/operators';
import { AlertController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { CommonUtils } from '../common-utils/common-utils';
import { Subscription } from 'rxjs/internal/Subscription';
import { NgxUiLoaderService } from 'ngx-ui-loader';

const API_URL = environment.apiUrl;
const API_MASTER = environment.apiMaster;

/* tslint:disable */ 
@Injectable()
export class InterceptorProvider implements HttpInterceptor {
  isparams = false;

  empId;
  lat;
  lng;
  zoom;
  origin;
  destination;
  authToken:any='';
  

  private logoutDataSubscribe: Subscription;

  // private _globalparamsData = null;
  private _globalparamsData = new BehaviorSubject(null);

  // get token session master as observable
  get globalparamsData(){
    return this._globalparamsData.asObservable();
  }

  // get token session master as a non observable
  public getTokenSessionMaster() {
    return this._globalparamsData.value;
  }

  constructor(
    private router: Router,
    public toastController: ToastController,
    private storage: Storage,
    private authService : AuthService,
    private commonUtils: CommonUtils,
    private alertController : AlertController,
    private http : HttpClient,
    private ngxLoader: NgxUiLoaderService,
) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authorization;
    // Keeps the original request params. as a new HttpParams
    let newParams = new HttpParams({fromString: request.params.toString()});

    let get_global_params = this.authService.getTokenSessionMaster();
    
    if(get_global_params != null && get_global_params.master == undefined && get_global_params.token !== undefined && get_global_params.token !== null){
      get_global_params.master = API_MASTER;
    }

    if(get_global_params != null && get_global_params.token !== undefined &&get_global_params.session !== undefined && get_global_params.master !== undefined){
      
      // newParams = newParams.append('token', get_global_params.token);
      // newParams = newParams.append('session', get_global_params.session);
      // newParams = newParams.append('master', get_global_params.master); 

      
    }
    
    if(get_global_params == null || get_global_params.token == null){
      authorization = 'Bearer '
      // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTY4LjAuMTc4XC9zc2RcL3NhZGhvbmFzdG9yZXNcL2FwaVwvbG9naW4iLCJpYXQiOjE2NDMyOTM4NjYsImV4cCI6MTY0MzMwMTA2NiwibmJmIjoxNjQzMjkzODY2LCJqdGkiOiJhMXV2dXBnMnpsQWFIWFR2Iiwic3ViIjoxNywicHJ2IjoiNGU3ODAyZmE5ZGJkMzA4YTdkNTFlNjc4MWNjNzNiZDczYmFkOWMwYiJ9.2vQlJ4dAD_5L6l2gyLeur2F_RjcWvT7nvbza9FouDQ8"
      // authorization = 'Bearer '+get_global_params.token;
    }else {
      authorization = 'Bearer '+ get_global_params.token;
    }
    
    // Clone the request with params instead of setParams

      const requestClone = request.clone({
        url: `${API_URL}/${request.url}`,
        setHeaders: {
          'Authorization': authorization,
        }
      });

      // return next.handle(requestClone);
      return next.handle(requestClone).pipe(
        map((event: HttpEvent<any>) => {
          let eventUrl;
          if (event instanceof HttpResponse) {

            if(event.body.return_status == 0){
              //this.router.navigateByUrl('/auth');
              // this.authService.logout();
              this.commonUtils.presentToast('error', event.body.message);
            }

            //token expire check
            if(event.body.return_token_expire){
              //this.router.navigateByUrl('/auth');
              this.authService.logout();
            }

            //show return_message
            if(!event.body.return_token_expire){
              // this.commonUtils.presentToast('info', event.body.return_message);
            }

          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {

          // this.router.navigateByUrl('/auth');


          if (error.status === 0) {
              this.ngxLoader.stop();

            this.commonUtils.presentToast('error', 'Please Check Your Network Connection!');
          }else if(error.status === 404){
              this.ngxLoader.stop();

            this.commonUtils.presentToast('error', 'Could not sign you up, please try again');
          }else if(error.status === 500){
              this.ngxLoader.stop();

            this.commonUtils.presentToast('error', 'Token not valid');

            // this.authService.logout();
            // this.router.navigateByUrl('/home');
          }else if(error.status === 401){
              this.ngxLoader.stop();

            this.commonUtils.presentToast('error', 'Could not sign you up, please try again');
            this.authService.logout();
            // this.router.navigateByUrl('/home');
          }else {
              this.ngxLoader.stop();

            this.commonUtils.presentToast('error', error.error.messagee);
          }
          return throwError(error);
        })
      );
  }

  // reload alert
    async logoutAlert() {
      const reload = await this.alertController.create({
        header: 'Logout',
        message: 'Do you want to logout from other devices?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'popup-cancel-btn',
            handler: (blah) => {
              console.log('Confirm Cancel: blah');
            }
          }, {
            text: 'Ok',
            cssClass: 'popup-ok-btn',
            handler: () => {
              console.log('Confirm Okay');
            }
          }
        ]
      });

      await reload.present();
    }
  // reload page end


  /* async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      showCloseButton: true,
      animated:true,
      cssClass:"my-tost-custom-class",
      translucent: true,
      duration: 2000
    });
    toast.present();
  } */

  // ----------- destroy subscription start ---------
    ngOnDestroy() {
      if(this.logoutDataSubscribe !== undefined){
        this.logoutDataSubscribe.unsubscribe();
      }
    }
  // destroy subscription end
  
  }

  
